import { render } from "./ClinicBranding.vue?vue&type=template&id=030da8cc&scoped=true"
import script from "./ClinicBranding.vue?vue&type=script&lang=js"
export * from "./ClinicBranding.vue?vue&type=script&lang=js"

import "./ClinicBranding.vue?vue&type=style&index=0&id=030da8cc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030da8cc"]])

export default __exports__